import React, {Component, useState} from "react";
import moment from "moment-timezone";
import {Modal, ModalBody} from 'reactstrap'
import PostEditor from '../socialPostEditor/PostEditor';
import modalService from "../../../../components/modal/modalService";

import {UploadGallery} from "./UploadGallery";
import {observer, inject} from "mobx-react"
import {ToastService} from '../../../../components/toasts/Toasts';

const scheduledFormat = 'dddd, MMMM Do YYYY, h:mm a zz';

export const CreateScheduleCard = inject("scheduledPostStore")(observer(class CreateScheduleCard extends Component {
  state = {
    key: 0,
    postStatuses: [] // success / failure messages for each post
  };

  resetPostStatuses = (cb) => {
    // Run this before saving posts to clear error message state
    this.setState({
      postStatuses: []
    }, cb)
  };

  render() {
    return (
      <PostEditor
        key={this.state.key}
        showCancelButton={false}
        preSavePost={this.resetPostStatuses.bind(this)}
        onComplete={(result) => {
          if (result) {
            this.props.scheduledPostStore.updateFilters({}) // aka, reload
          }

          const cb = (post) => {
            
            let scheduled = moment(post.scheduledTime);
            const beforeNow = scheduled.isSameOrBefore(moment());

            let errorMessage = this.state.postStatuses.filter(x => x.error !== undefined).map(status => {
              const remoteLocation = status.post.publishTo && status.post.publishTo.length ? `${status.post.publishTo[0].label}: ` : "";
              return remoteLocation + status.error
            });

            let successMessage;
            if(post.requiresApproval){
              successMessage = 'Post(s) submitted for approval.';
            }else{
              successMessage = (
                beforeNow
                  ? 'Post(s) will be published shortly.'
                  : `Post(s) scheduled for ${scheduled.format(scheduledFormat)}.`
              );
            }

            if (errorMessage.length > 0) {
              errorMessage = ["With the following issues:"].concat(errorMessage);
              const messagesInElements = errorMessage.map(message => <div>{message}</div>);
              const messagesWrapper = <div>{messagesInElements}</div>;
              ToastService.warning(`Exception${errorMessage.length > 1 ? "s" : ""}`, messagesWrapper);
            }else{
              ToastService.success("Success", successMessage);
            }
            
            if (this.props.onComplete) this.props.onComplete(); // We set this handler in the PublishingView.
          };

          let error;
          if (result && result.response && result.response.data && result.response.data.error) {
            const attemptedPost = result.response.data.post;
            error = result.response.data.error;

            this.setState(currentState => ({
              postStatuses: currentState.postStatuses.concat([{
                "post": attemptedPost,
                error
              }])
            }), () => cb(attemptedPost));
          } else if (result && result.name === "Error") {
            const post = result;
            error = result.message || 'Other';
            console.error('Unexpected error result: ', result);

            ToastService.error("Error", result.message);
            
            this.setState(currentState => ({
              postStatuses: currentState.postStatuses.concat([{
                post,
                error
              }])
            }));
          } else if (result) {
            const post = result;

            this.setState(currentState => ({
              postStatuses: currentState.postStatuses.concat([{
                post,
                error: undefined
              }])
            }), () => cb(post));
          } 
          this.setState({key: this.state.key + 1})
        }}
        openModal={component => modalService.requestModalV2({
          modal: <Modal modalClassName="overflow-hidden vh-100" contentClassName="upload-gallery-modal-content" scrollable={true}  isOpen={true} size="lg" backdrop={true} toggle={modalService.closeModal}>{component}</Modal>
        })}
        closeModal={() => modalService.closeModal()}
      >
        <UploadGallery />
      </PostEditor>
    );
  }
}));

// sigh
export const EditScheduleModalTrigger = inject("scheduledPostStore")(({children, edit, preSavePost, ...props}) => {
    let onClose = () => true;
    return (
      <a
        {...props}
        onClick={() => {
          return modalService.requestModalV2({
            modal: <EditScheduleModalBody scheduledPostStore={props.scheduledPostStore} preSavePost={preSavePost} edit={edit} bindOnClose={fn => onClose = fn} />
          })
        }}
      >
        {children}
      </a>
    );
});

class EditScheduleModalBody extends Component {

  constructor(state) {
    super(state);
    this.state = {
      modalComponent: undefined
    }
  }

  render() {
    const {preSavePost, edit, onClose} = this.props;
    return (
      <Modal
        onClose={() => {
          this.setState({modalComponent: undefined});
          modalService.closeModal();
          onClose && onClose();
        }}
        isOpen={true}
        size="lg"
      >
        <div
          style={this.state.modalComponent ? {display: 'none'} : {}}> {/* just hide the editor rather than removing it, so that modal callbacks work*/}
          <ModalBody>
            <PostEditor
              post={edit}
              preSavePost={preSavePost}
              showCancelButton={true}
              onComplete={(result) => {
                if (result) {
                  this.props.scheduledPostStore.updateFilters({}) // aka, reload
                  ToastService.success(
                    "Updated", 
                    result.requiresApproval ? "Post re-submitted for approval." : "Post updated."
                  );
                }
                modalService.closeModal();
              }}
              openModal={component => this.setState({modalComponent: component})}
              closeModal={() => this.setState({modalComponent: undefined})}
            />
          </ModalBody>
        </div>
        {this.state.modalComponent}
      </Modal>
    );
  }
}
